import { getDealId } from 'sonata-static-storage/lib/helpers/deal.helpers';

import type { DealInterface } from 'sonata-static-storage/lib/schemas/premium/deal.schema';
import type { DealPublisherInterface } from 'sonata-static-storage/lib/schemas/premium/dealPublisher.schema';

export const getDealRow =
  (
    formatMessage: (message: { defaultMessage: string; id: string }) => string,
    setEditedDeal: (deal: Partial<DealInterface<string>>) => void,
    dealsPublishers: DealPublisherInterface<string>[]
  ) =>
  (deal: DealInterface<string>) => {
    let publisherName = 'N/A';
    if (deal.publisher) {
      const publisherData = dealsPublishers.find(p => p._id === deal.publisher);
      publisherName = publisherData?.name || 'N/A';
    }
    return {
      ...deal,
      bidFloorText: `${deal.bidFloor} ${formatMessage({ defaultMessage: deal.currencyCode || '', id: `common.currencies.${deal.currencyCode}` })}`,
      country: deal.country
        ? formatMessage({ defaultMessage: deal.country, id: `common.countries.${deal.country}` })
        : 'N/A',
      editButton: {
        icon: 'fa-solid fa-pen-to-square',
        id: `deal-update-${deal._id}`,
        onClick: () => {
          setEditedDeal(deal);
        },
        shape: 'link' as const,
        size: 'ultraSmall' as const,
        title: formatMessage({
          defaultMessage: 'Edit deal',
          id: 'menu.deals.list.editDeal'
        }),
        type: 'primary' as const
      },
      id: getDealId(deal),
      publisher: publisherName
    };
  };
